module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAAd0SU1FB94LGwsWKDFQxLwAAAAiSURBVDjLY2AYBaOAUsCopKT0n5YWMNHaB0PfglEwCigHAGA/AW2PxVkiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_subtramo.png
// module id = 71DA
// module chunks = 0